module.exports = __webpack_public_path__ + "img/bg-solution-left-header.21313252.png";